<template>
  <component :is="iconComponent" />
</template>

<script lang="ts">
import IconSearchEmpty159px from "@/common/components/icons/IconSearchEmpty159px.vue";
import IconSearchEmpty103px from "@/common/components/icons/IconSearchEmpty103px.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    iconSize: { type: Number, default: 159 }
  },
  components: {
    IconSearchEmpty159px,
    IconSearchEmpty103px
  }
})
export default class IconSearchEmpty extends Vue {
  iconSize!: number;

  get iconComponent() {
    const { iconSize } = this;
    return `IconSearchEmpty${iconSize}px`;
  }
}
</script>
